/** Created by azhou on 2019/2/22.*/
v
<template>
    <div>
      <!--销售关联酒店-->
      <ContactBasic @saveInfo="saveBasicInfo"/>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import ContactBasic from '../../StoreInfo/BasicInfo/Comps/ContactBasic.vue'
  export default {
    name: 'RegBasicClose', 
    components: { ContactBasic },
    computed: {
      ...mapGetters(['storeInfo']),
    },
    created() {},
    methods: {
      ...mapActions(['saveStoreInfo']),
      /*保存用户基础信息*/
      saveBasicInfo(id) {
        let name = id==1?'resBasicInfo':'regVerify';
        this.$router.push({ name: name,query:{step:id,sales:1} });
      }
    }
  }
</script>
